import type { User } from 'belo-js-sdk';

import type { ReactEventHandler } from '../types';

import type { StreamMessage } from '../../../context/ChannelStateContext';

import type { DefaultBeloChatGenerics } from '../../../types/types';

export type UserEventHandler<
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
> = (event: React.BaseSyntheticEvent, user: User<BeloChatGenerics>) => void;

export const useUserHandler = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>(
  message?: StreamMessage<BeloChatGenerics>,
  eventHandlers?: {
    onUserClickHandler?: UserEventHandler<BeloChatGenerics>;
    onUserHoverHandler?: UserEventHandler<BeloChatGenerics>;
  },
): {
  onUserClick: ReactEventHandler;
  onUserHover: ReactEventHandler;
} => ({
  onUserClick: (event) => {
    if (typeof eventHandlers?.onUserClickHandler !== 'function' || !message?.user) {
      return;
    }
    eventHandlers.onUserClickHandler(event, message.user);
  },
  onUserHover: (event) => {
    if (typeof eventHandlers?.onUserHoverHandler !== 'function' || !message?.user) {
      return;
    }

    eventHandlers.onUserHoverHandler(event, message.user);
  },
});
